import React, { useEffect, useRef, useState } from 'react'
import './player-store.styles.scss';
import { useAsyncError, useLocation } from 'react-router-dom';
import SearchBar from '@/components/SHARED/search-bar/search-bar.component';
import StoreItemCard from './store-components/store-item-card.component';
import CartWidget from './store-components/cart-widget.component';
import StoreContributionCard from './store-components/store-contribution-card.component';
import ItemSearchBar from '@/components/SHARED/search-bar/item-search-bar.component';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import PlayerCollectibles from './player-collectibles.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { useSelector } from 'react-redux';


const PlayerStore = ({ 
    gameData, 
    playerData, 
    gameElements, 
    availableItems,
    itemType, 
    gameStats,
    teamMembers,
    saleList
}) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ itemsToDisplay, setItemsToDisplay ] = useState([]);
    const [ filteredItems, setFilteredItems ] = useState([]);
    const [ collections, setColletions ] = useState([]);
    const availableRef = useRef();
    const location = useLocation();

    useEffect(() => {
        if (!availableItems || !itemType || !gameElements) return;
        // console.log(itemType);
        let availItems = availableItems
        .filter(e => e.opt_itemType === itemType);
        // console.log(availItems);
        availableRef.current = [...availItems];
        setFilteredItems([...availableRef.current]);
        const coll = Object.values(gameElements).filter(e => e.type === 'collection');
        setColletions([...coll]);
        console.log(coll);
        setItemsToDisplay([...availableRef.current]);
    }, [availableItems, itemType, gameElements]);

    function search(text) {
        if (!text) {
            setItemsToDisplay([...availableRef.current])
            return;
        }
        let tempItems = [...availableRef.current]
        let filteredItems = tempItems
        .filter(i => 
            i.name.toLowerCase().includes(text.toLowerCase()) ||
            i.desc.toLowerCase().includes(text.toLowerCase())
        )
        setItemsToDisplay([...filteredItems]);
    }

    return (
        <div className={`player-store ${screenSize}`}>
            <div className='left-col'>
                
                {
                    (itemType && itemType !== 'collectible')
                    ?
                    <>
                    <ItemSearchBar 
                        availableItems={filteredItems}
                        setItemsToDisplay={setItemsToDisplay} 
                        itemType={itemType}
                        collections={collections}
                        noTypes={true}
                    />
                    <div className="g-space-1"></div>
                    <div className='store-item-list'>
                        {
                            (itemsToDisplay.length > 0)
                            ?
                            itemsToDisplay.sort((a,b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
                            .map(i => (
                                <div
                                    className='card-container' 
                                    key={i.id}>
                                    {
                                        (i.opt_itemType === 'contribution')
                                        ?
                                        <StoreContributionCard 
                                            item={i} 
                                            playerData={playerData} 
                                            gameStats={gameStats} 
                                            gameElements={gameElements}
                                            teamMembers={teamMembers}
                                        />
                                        :
                                        <StoreItemCard 
                                            item={i} 
                                            playerData={playerData} 
                                            gameStats={gameStats} 
                                            gameElements={gameElements}
                                            teamMembers={teamMembers}
                                            saleList={saleList}
                                        />
                                    }
                                </div>
                            ))
                            :
                            <div className='center-col'>
                                <h4>No items for sale in this category.</h4>
                            </div>
                        }
                    </div>
                    </>
                    :
                    (itemType && itemType === 'collectible')
                    ?
                    <PlayerCollectibles
                        playerData={playerData}
                        gameStats={gameStats}
                        gameElements={gameElements}
                        teamMembers={teamMembers}
                        collections={collections}
                        itemsToDisplay={itemsToDisplay}
                        saleList={saleList}
                    />
                    :
                    <div className='center-col'>
                        <ThreeDotsLoader />
                    </div>
                }                
            </div>
            {
                (screenSize !== 'mobile' && screenSize !== 'tablet') &&
                <div className='right-col'>
                    <div className='col-content'>
                        <section className='g-list-item current-balance'>
                            <span>Current Balance: </span>
                            <div className='balance'>
                                <ImageContainer src="/images/icons/coin.png" className='balance-coin' />
                                <span>{playerData.currency ? playerData.currency.toLocaleString() : 0}</span>
                            </div>
                        </section>
                        <div className="g-space-1"></div>
                        <div className='g-list-item'>
                            <CartWidget
                                playerData={playerData} 
                            />
                            
                        </div> 
                    </div>
                </div>
            }
        </div>
    )
}

export default PlayerStore;